import React, { Fragment, useEffect, useState } from "react";
import BetSlipContext from "../../../context/BetSlipContext";
import { useContextSelector } from "use-context-selector";
import AuthContext from "../../../context/AuthContext";
import { inRange, isEmpty, startCase } from "lodash";
import { formatWithCommas } from "../../../Utils/Toast";

const HomeRight = () => {
  const [tab, setTab] = useState(true);
  const numberArray = [10, 100, 200, 500, 10000, 20000];

  const user = useContextSelector(AuthContext, (ctx) => {
    return ctx.user;
  });
  const setBetSlipObject = useContextSelector(BetSlipContext, (ctx) => {
    return ctx.setBetSlipObject;
  });
  const betSlipObject = useContextSelector(BetSlipContext, (ctx) => {
    return ctx.betSlipObject;
  });
  const betLoader = useContextSelector(AuthContext, (ctx) => {
    return ctx.betLoader;
  });
  const profileData = useContextSelector(AuthContext, (ctx) => {
    return ctx.profileData;
  });

  const limit = useContextSelector(BetSlipContext, (ctx) => {
    return ctx.limit;
  });
  const setShowBetDialog = useContextSelector(BetSlipContext, (ctx) => {
    return ctx.setShowBetDialog;
  });

  const setResetBetPosition = useContextSelector(BetSlipContext, (ctx) => {
    return ctx.setResetBetPosition;
  });
  const handelPlaceBetFair = useContextSelector(BetSlipContext, (ctx) => {
    return ctx.handelPlaceBetFair;
  });
  const handelPlaceFancy = useContextSelector(BetSlipContext, (ctx) => {
    return ctx.handelPlaceFancy;
  });
  const handelPlaceBookmaker = useContextSelector(BetSlipContext, (ctx) => {
    return ctx.handelPlaceBookmaker;
  });
  const toastObject = useContextSelector(BetSlipContext, (ctx) => {
    return ctx.toastObject;
  });
  const setToastObject = useContextSelector(BetSlipContext, (ctx) => {
    return ctx.setToastObject;
  });
  const setLoginModal = useContextSelector(BetSlipContext, (ctx) => {
    return ctx.setLoginModal;
  });
  const handelPlaceSportBook = useContextSelector(BetSlipContext, (ctx) => {
    return ctx.handelPlaceSportBook;
  });

  const handelPlaceToss = useContextSelector(BetSlipContext, (ctx) => {
    return ctx.handelPlaceToss;
  });
  const [bidPriceDisabled, setBidPricDisabled] = useState(true);
  const [timeLeft, setTimeLeft] = useState(limit?.betDelay || 5);
  useEffect(() => {
    if (
      inRange(
        Number(betSlipObject?.bidPrice),
        limit?.minAmount || 1,
        limit?.maxAmount + 1 || 100
      )
    ) {
      setBidPricDisabled(false);
    } else {
      setBidPricDisabled(true);
    }
  }, [betSlipObject, limit]);
  const placeBet = () => {
    if (!isEmpty(user)) {
      if (
        betSlipObject?.playType == "betFaire" ||
        betSlipObject?.playType == "multi" ||
        betSlipObject?.playType == "home"
      ) {
        handelPlaceBetFair();
      } else if (betSlipObject?.playType == "fancy") {
        handelPlaceFancy();
      } else if (betSlipObject?.playType == "bookmaker") {
        handelPlaceBookmaker();
      } else if (betSlipObject?.playType == "sportBook") {
        handelPlaceSportBook();
      } else if (betSlipObject?.playType == "toss") {
        handelPlaceToss();
      }
    } else {
      setShowBetDialog(false);
      setLoginModal(true);
    }
  };

  useEffect(() => {
    if (betLoader) {
      if (timeLeft <= 0) return;

      const interval = setInterval(() => {
        setTimeLeft((t) => t - 1);
      }, 1000);

      return () => clearInterval(interval);
    }
  }, [timeLeft, betLoader]);

  useEffect(() => {
    if (toastObject?.status) {
      const timer = setTimeout(() => {
        setToastObject({});
      }, 4000);

      return () => clearTimeout(timer); // Cleanup on unmount
    }
  }, [toastObject]);
  return (
    <div className="col-right">
      <div className={`slip-wrap no-open-bet_slip ${!tab ? "close" : ""}`}>
        <h3 onClick={() => setTab(!tab)}>
          <a className="to-expand" style={{ cursor: "pointer" }}>
            Bet Slip
          </a>
        </h3>
        {isEmpty(betSlipObject) && isEmpty(toastObject?.message) &&
          <p id="noBetSlipInfo" style={{ display: "block" }}>
            Click on the odds to add selections to the betslip.
          </p>}
        {!isEmpty(toastObject?.message) &&
          toastObject?.status &&
          toastObject?.gameType == "betfair" && (
            <div className="message-bet">
              <h4 id="errorMsg" className={toastObject?.type}>
                {toastObject?.message}
              </h4>
            </div>
          )}
        {betLoader ? (
          <ul id="loadingMsg" className="loading">
            <li>
              <img src="/assets/images/loading40.gif" />
            </li>
            <li id="countDownTime">
              {" "}
              Placing your bets, Please wait {timeLeft} sec remaining…
            </li>
          </ul>
        ) : (
          !isEmpty(betSlipObject) &&
          betSlipObject?.playType == "betFaire" && (
            <>
              <div
                id="betSlipBoard"
                className="bet_slip"
                style={{ display: "block" }}
              >
                <div
                  id="betList"
                  className="slip-list"
                  style={{ "max-height": "calc(100% - 86px)" }}
                >
                  <ul
                    id="backSlipHeader"
                    className="slip-head"
                    name="slipHeader"
                    style={{ display: "block" }}
                  >
                    <li className="col-bet">
                      {startCase(betSlipObject?.betType)} (Bet For)
                    </li>
                    <li id="oddsHeader" className="col-odd">
                      Odds
                    </li>
                    <li className="col-stake">Stake</li>
                    <li className="col-profit">Profit</li>
                  </ul>
                  <div
                    id="header_Back_34941733"
                    style={{ display: "block" }}
                    count={1}
                  >
                    <h4>
                      <img
                        className="icon-in_play"
                        src="/images/transparent.gif"
                      />{" "}
                      {betSlipObject?.object?.eventName}
                    </h4>
                    <dl
                      className={`slip-${betSlipObject?.playType == "sportBook"
                          ? "book"
                          : ["lay", "No"].includes(betSlipObject?.betType)
                            ? "lay"
                            : "back"
                        }`}
                      style={{ display: "block" }}
                    >
                      <dt>
                        <a
                          onClick={() => {
                            setShowBetDialog(false);
                            setResetBetPosition(true);
                          }}
                          id="delete"
                          className="delete"
                          style={{ cursor: "pointer" }}
                        >
                          delete
                        </a>
                        <span className="short-amount">
                          {betSlipObject?.teamName}
                        </span>
                        <span id="marketName">Match Odds</span>
                      </dt>
                      <dd className="col-odd">
                        <input
                          id="odds"
                          type="text"
                          disabled
                          value={betSlipObject?.odds}
                          autoComplete="off"
                        />
                      </dd>
                      <dd className="col-stake">
                        <input
                          id="inputStake"
                          type="text"
                          maxLength={7}
                          value={betSlipObject?.bidPrice}
                        />
                      </dd>
                      <dd id="profitLiability" className="col-profit">
                        0.00
                      </dd>
                      <dd
                        id="stakePopupList"
                        className="col-stake_list"
                        stakepopuplisttype="extended"
                        style={{ display: "block" }}
                        bet="bet_34941733_1_250382399_414464_0_00_1"
                      >
                        <ul>
                          {(profileData?.stake?.length > 0
                            ? profileData?.stake?.sort(function (a, b) {
                              return a - b;
                            })
                            : numberArray
                          )
                            ?.slice(0, 6)
                            ?.map((res) => {
                              return (
                                <li
                                  onClick={() => {
                                    setBetSlipObject({
                                      ...betSlipObject,
                                      bidPrice: Number(res),
                                    });
                                  }}
                                >
                                  <a
                                    className="btn"
                                    id="selectStake_1"
                                    style={{ cursor: "pointer" }}
                                  >
                                    {res}
                                  </a>
                                </li>
                              );
                            })}
                        </ul>
                      </dd>
                      <dd className="keep-option">
                        <p className="dynamic-min-bet">
                          Min Bet:{" "}
                          <strong id="dynamicMinBet">
                            {formatWithCommas(limit?.minAmount)}
                          </strong>
                        </p>
                      </dd>
                      <dd
                        id="inningsRuns"
                        className="inn_runs"
                        style={{ display: "none" }}
                      >
                        <dl>
                          <dt id="ifRuns" />
                          <dd>
                            <span id="runsPL" className="green" />
                          </dd>
                          <dt id="ifLess" />
                          <dd>
                            <span id="lessPL" className="green" />
                          </dd>
                        </dl>
                      </dd>
                    </dl>
                  </div>
                </div>
                <div id="betSlipFullBtn" className="full_btn">
                  <dl className="sum">
                    <dt>Liability</dt>
                    <dd>
                      <span id="total" className="red">
                        {betSlipObject?.bidPrice}
                      </span>
                    </dd>
                  </dl>
                  <ul className="btn-wrap">
                    <li>
                      <a
                        onClick={() => {
                          setShowBetDialog(false);
                          setResetBetPosition(true);
                        }}
                        id="cancelAll"
                        className="btn"
                        style={{ cursor: "pointer" }}
                      >
                        Cancel
                      </a>
                    </li>
                    <li>
                      <a
                        onClick={() => {
                          placeBet();
                        }}
                        id="placeBets"
                        className={`btn-send ${bidPriceDisabled ? "disable" : ""
                          }`}
                        style={{ cursor: "pointer" }}
                        tabIndex={0}
                      >
                        Place Bets
                      </a>
                    </li>
                  </ul>
                  <ul className="slip-option">
                    <li>
                      <input id="comfirmBets" type="checkbox" />
                      <label htmlFor="comfirmBets">
                        Please confirm your bets.
                      </label>
                    </li>
                  </ul>
                </div>
              </div>
            </>
          )
        )}
      </div>
      <div
        className="matched-wrap"
        style={{ display: "none", height: "calc(100% - 301px)" }}
      >
        <h3>
          <a
            id="openBetsRefresh"
            className="slip_refresh"
            style={{ cursor: "pointer" }}
          >
            Refresh
          </a>
          <a className="to-expand" style={{ cursor: "pointer" }}>
            Open Bets
          </a>
        </h3>
        <div className="message-bet">
          <h4 id="oneClickMsg" className style={{ display: "none" }} />
        </div>
        <div
          id="oneClickLoadingWrap"
          className="one_click-loading"
          style={{ display: "none" }}
        >
          <div
            id="loadPending"
            className="load-pending"
            style={{ display: "none" }}
          >
            <strong id="pendingNum" />
            pending...
          </div>
          <ul className="loading">
            <li>
              <img src="https://statics3.e2betms.xyz/images/loading40.gif" />
            </li>
            <li id="oneClickTime">Place Bets</li>
          </ul>
        </div>
        <div className="message-bet">
          <h4 id="editErrorMsg" className="error" style={{ display: "none" }} />
          <p id="editBetMsg" className="warning" style={{ display: "none" }} />
        </div>
        <ul id="processingImg" className="loading" style={{ display: "none" }}>
          <li>
            <img src="https://statics3.e2betms.xyz/images/loading40.gif" />
          </li>
          <li>Processing...</li>
        </ul>
        <div id="matchSection" style={{}}>
          <div id="openBetSelectionBox" className="slip-sort">
            <select id="selectMenu" name></select>
            <option
              id="optionTemplate"
              value
              eventid
              marketid
              style={{ display: "none" }}
            />
          </div>
          <div
            id="openBetSlip"
            className="bet_slip over-wrap"
            style={{ height: "calc(100% - 35px)" }}
          >
            <ul
              id="unMatchTicketHead"
              className="slip-head"
              style={{ display: "none" }}
            >
              <li className="col-bet">
                <strong id="headerInfo">Unmatched</strong>
              </li>
            </ul>
            <div
              id="unMatchTicketList"
              className="slip-list"
              style={{ display: "none" }}
            >
              <ul
                id="backSlipHeader"
                className="matched-head"
                style={{ display: "none" }}
              >
                <li className="col-bet">Back (Bet For)</li>
                <li className="col-odd">Odds</li>
                <li className="col-stake">Stake</li>
                <li className="col-profit">Profit</li>
              </ul>
              <ul
                id="laySlipHeader"
                className="matched-head"
                style={{ display: "none" }}
              >
                <li className="col-bet">Lay (Bet Against)</li>
                <li className="col-odd">Odds</li>
                <li className="col-stake">Stake</li>
                <li className="col-profit">Liability</li>
              </ul>
              <dl
                id="unMatchTicketTemplate"
                className="slip-lay"
                style={{ display: "none" }}
              >
                <dd id="betInfo" className="refer" style={{ display: "none" }}>
                  <span id="betId">Ref: --</span>
                  <span id="placeDate">xx-xx-2016 --:--</span>
                </dd>
                <dt id="marketNameDt">
                  <a
                    id="delete"
                    className="delete"
                    style={{ cursor: "pointer" }}
                  >
                    delete
                  </a>
                  <span id="slipType" className="slip-type">
                    --
                  </span>
                  <span id="marketName">--</span>
                </dt>
                <dd id="price" className="col-odd">
                  --
                </dd>
                <dd id="size" className="col-stake">
                  --
                </dd>
                <dd id="profitLiability" className="col-profit">
                  --
                </dd>
                <dd
                  id="inningsRuns"
                  className="inn_runs"
                  style={{ display: "none" }}
                >
                  <dl>
                    <dt id="ifRuns" />
                    <dd>
                      <span id="runsPL" className="green">
                        $0.00
                      </span>
                    </dd>
                    <dt id="ifLess" />
                    <dd>
                      <span id="lessPL" className="green">
                        $0.00
                      </span>
                    </dd>
                  </dl>
                </dd>
                <dd
                  id="keepOption"
                  className="keep-option"
                  style={{ display: "none" }}
                >
                  At In-Play, this unmatched bet will be
                  <span id="editKeepOption" className="edit"></span>
                </dd>
              </dl>
            </div>
            <div id="unMatchFullBtn" className="full_btn">
              <dl className="sum"></dl>
              <ul className="btn-wrap">
                <li>
                  <a
                    id="cancelAllUnMatch"
                    className="btn"
                    style={{ cursor: "pointer" }}
                    tabIndex={0}
                  >
                    Cancel All
                  </a>
                </li>
                <li>
                  <a
                    id="editAllBets"
                    className="btn-send"
                    style={{ cursor: "pointer" }}
                    tabIndex={0}
                  >
                    Edit Bets
                  </a>
                </li>
              </ul>
            </div>
            <ul
              id="stakePopupList"
              className="stake-popup"
              stakepopuplisttype="template"
              style={{ display: "none" }}
            >
              <li>
                <a
                  id="selectStake_1"
                  stake={1000}
                  style={{ cursor: "pointer" }}
                >
                  1000
                </a>
              </li>
              <li>
                <a
                  id="selectStake_2"
                  stake={3000}
                  style={{ cursor: "pointer" }}
                >
                  3000
                </a>
              </li>
              <li>
                <a
                  id="selectStake_3"
                  stake={5000}
                  style={{ cursor: "pointer" }}
                >
                  5000
                </a>
              </li>
              <li>
                <a
                  id="selectStake_4"
                  stake={50000}
                  style={{ cursor: "pointer" }}
                >
                  50000
                </a>
              </li>
              <li>
                <a
                  id="selectStake_5"
                  stake={200000}
                  style={{ cursor: "pointer" }}
                >
                  200000
                </a>
              </li>
              <li>
                <a
                  id="selectStake_6"
                  stake={300000}
                  style={{ cursor: "pointer" }}
                >
                  300000
                </a>
              </li>
            </ul>
            <div
              id="oddsTipsPopup"
              className="tips-popup"
              style={{ display: "none" }}
            >
              min 1.01
            </div>
            <div
              id="stakeTipsPopup"
              className="tips-popup"
              style={{ display: "none" }}
            >
              Min 4.00
            </div>
            <div
              id="editUnMatchedList"
              className="slip-list"
              style={{ display: "none" }}
            >
              <dd
                id="stakePopupList"
                className="col-stake_list"
                stakepopuplisttype="template"
                style={{ display: "none" }}
              >
                <ul>
                  <li>
                    <a
                      className="btn"
                      id="selectStake_1"
                      stake={1000}
                      style={{ cursor: "pointer" }}
                    >
                      1000
                    </a>
                  </li>
                  <li>
                    <a
                      className="btn"
                      id="selectStake_2"
                      stake={3000}
                      style={{ cursor: "pointer" }}
                    >
                      3000
                    </a>
                  </li>
                  <li>
                    <a
                      className="btn"
                      id="selectStake_3"
                      stake={5000}
                      style={{ cursor: "pointer" }}
                    >
                      5000
                    </a>
                  </li>
                  <li>
                    <a
                      className="btn"
                      id="selectStake_4"
                      stake={50000}
                      style={{ cursor: "pointer" }}
                    >
                      50000
                    </a>
                  </li>
                  <li>
                    <a
                      className="btn"
                      id="selectStake_5"
                      stake={200000}
                      style={{ cursor: "pointer" }}
                    >
                      200000
                    </a>
                  </li>
                  <li>
                    <a
                      className="btn"
                      id="selectStake_6"
                      stake={300000}
                      style={{ cursor: "pointer" }}
                    >
                      300000
                    </a>
                  </li>
                </ul>
              </dd>
              <ul
                id="backSlipHeader"
                className="matched-head"
                style={{ display: "none" }}
              >
                <li className="col-bet">Back (Bet For)</li>
                <li className="col-odd">Odds</li>
                <li className="col-stake">Stake</li>
                <li className="col-profit">Profit</li>
              </ul>
              <ul
                id="laySlipHeader"
                className="matched-head"
                style={{ display: "none" }}
              >
                <li className="col-bet">Lay (Bet Against)</li>
                <li className="col-odd">Odds</li>
                <li className="col-stake">Stake</li>
                <li className="col-profit">Liability</li>
              </ul>
              <dl
                id="editUnMatchedTemplate"
                className="slip-lay"
                style={{ display: "none" }}
              >
                <dd id="betInfo" className="refer" style={{ display: "none" }}>
                  <span id="betId">Ref: --</span>
                  <span id="placeDate">xx-xx-2016 --:--</span>
                </dd>
                <dt id="marketNameDt">
                  <a
                    id="delete"
                    className="delete"
                    style={{ cursor: "pointer" }}
                  >
                    delete
                  </a>
                  <span id="slipType" className="slip-type">
                    --
                  </span>
                  <span id="marketName">--</span>
                </dt>
                <dd id="price" className="col-odd">
                  <input
                    id="odds"
                    type="text"
                    maxLength={6}
                    autoComplete="off"
                  />
                  <ul className="odd-add">
                    <li>
                      <a
                        id="oddsUp"
                        className="up"
                        style={{ cursor: "pointer" }}
                      >
                        up
                      </a>
                    </li>
                    <li>
                      <a
                        id="oddsDown"
                        className="down"
                        style={{ cursor: "pointer" }}
                      >
                        down
                      </a>
                    </li>
                  </ul>
                  <ul id="oddsTipsPoint" />
                </dd>
                <dd id="size" className="col-stake">
                  <input
                    id="inputStake"
                    type="text"
                    defaultValue
                    maxLength={10}
                  />
                  <ul id="listPoint" />
                </dd>
                <dd id="profitLiability" className="col-profit">
                  --
                </dd>
                <dd
                  id="inningsRuns"
                  className="inn_runs"
                  style={{ display: "none" }}
                >
                  <dl>
                    <dt id="ifRuns" />
                    <dd>
                      <span id="runsPL" className="green">
                        $0.00
                      </span>
                    </dd>
                    <dt id="ifLess" />
                    <dd>
                      <span id="lessPL" className="green">
                        $0.00
                      </span>
                    </dd>
                  </dl>
                </dd>
                <dd
                  id="keepOptionBox"
                  className="keep-option"
                  style={{ display: "none" }}
                >
                  At In-Play
                  <input name="keepOption" id="cancel" type="checkbox" />
                  <label htmlFor="cancel">cancel</label>
                  <input name="keepOption" id="keep" type="checkbox" />
                  <label htmlFor="keep">keep</label>
                  <p className="dynamic-min-bet">
                    Min Bet: <strong id="dynamicMinBet" />
                  </p>
                </dd>
              </dl>
            </div>
            <div
              id="editUnMatchFullBtn"
              className="full_btn"
              style={{ display: "none" }}
            >
              <dl className="sum"></dl>
              <ul className="btn-wrap">
                <li>
                  <a
                    id="cancelAllUnMatch"
                    className="btn"
                    style={{ cursor: "pointer" }}
                    tabIndex={0}
                  >
                    Cancel All Bets
                  </a>
                </li>
                <li className="edit-function">
                  <a
                    id="okBtn"
                    className="btn-send"
                    style={{ cursor: "pointer" }}
                    tabIndex={0}
                  >
                    OK
                  </a>
                  <a
                    id="resetBtn"
                    className="btn"
                    style={{ cursor: "pointer" }}
                    tabIndex={0}
                  >
                    Reset
                  </a>
                </li>
              </ul>
            </div>
            <ul id="txnHead" className="slip-head" style={{ display: "none" }}>
              <li className="col-bet">
                <strong>Matched</strong>
              </li>
            </ul>
            <div
              id="txnList"
              className="slip-list"
              name="txn"
              style={{ display: "none" }}
            >
              <ul
                id="backSlipHeader"
                className="matched-head"
                style={{ display: "none" }}
              >
                <li className="col-bet">Back (Bet For)</li>
                <li className="col-odd">Odds</li>
                <li className="col-stake">Stake</li>
                <li className="col-profit">Profit</li>
              </ul>
              <ul
                id="laySlipHeader"
                className="matched-head"
                style={{ display: "none" }}
              >
                <li className="col-bet">Lay (Bet Against)</li>
                <li className="col-odd">Odds</li>
                <li className="col-stake">Stake</li>
                <li className="col-profit">Liability</li>
              </ul>
              <ul
                id="backLaySlipHeader"
                className="matched-head"
                style={{ display: "none" }}
              >
                <li className="col-bet">Back/Lay</li>
                <li className="col-odd">Odds</li>
                <li className="col-stake">Stake</li>
                <li className="col-profit">Profit/Liability</li>
              </ul>
              <ul
                id="fancyYesHeader"
                className="matched-head"
                style={{ display: "none" }}
              >
                <li id="colBet" className="col-bet">
                  Yes
                </li>
                <li id="runsOdds" className="col-odd">
                  Runs/Odds
                </li>
                <li className="col-stake">Stake</li>
                <li className="col-profit">Profit</li>
              </ul>
              <ul
                id="fancyNoHeader"
                className="matched-head"
                style={{ display: "none" }}
              >
                <li className="col-bet">No</li>
                <li id="runsOdds" className="col-odd">
                  Runs/Odds
                </li>
                <li className="col-stake">Stake</li>
                <li className="col-profit">Liability</li>
              </ul>
              <ul
                id="fancyYesNoHeader"
                className="matched-head"
                style={{ display: "none" }}
              >
                <li className="col-bet">Yes/No</li>
                <li id="runsOdds" className="col-odd">
                  Runs/Odds
                </li>
                <li className="col-stake">Stake</li>
                <li className="col-profit">Profit/Liability</li>
              </ul>
              <dl
                id="txnTemplate"
                className="slip-back"
                style={{ display: "none" }}
              >
                <dd id="betInfo" className="refer" style={{ display: "none" }}>
                  <span id="betId">Ref: --</span>
                  <span id="placeDate">xx-xx-2016 --:--</span>
                </dd>
                <dt>
                  <span id="slipType" className="slip-type">
                    --
                  </span>
                  <p id="slipPredict" className="slip-predict">
                    <span id="marketName">--</span>
                  </p>
                </dt>
                <dd id="price" className="col-odd">
                  --
                </dd>
                <dd id="size" className="col-stake">
                  --
                </dd>
                <dd id="profitLiability" className="col-profit">
                  --
                </dd>
              </dl>
            </div>
            <div className="full_btn">
              <ul className="slip-option">
                <li>
                  <input id="showBetInfo" type="checkbox" name="openOption" />
                  <label htmlFor="showBetInfo">Bet Info</label>
                </li>
                <li name="showTimeOption">
                  <input id="showTimeOrder" type="checkbox" />
                  <label htmlFor="showTimeOrder">Time Order</label>
                </li>
                <li name="txnOption">
                  <input id="consolidate" type="checkbox" name="openOption" />
                  <label htmlFor="consolidate">Consolidate</label>
                </li>
                <li name="txnOption">
                  <input id="averageOdds" type="checkbox" name="openOption" />
                  <label htmlFor="averageOdds">Average Odds</label>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomeRight;
